export function gen4() {
    return Math.random().toString(16).slice(-4);
}
export const idGenerator = (prefix) => (prefix || '').concat([gen4(), gen4(), gen4(), gen4(), gen4(), gen4(), gen4(), gen4()].join(''));
export default idGenerator;
//# sourceMappingURL=idGenerator.js.map